import { render } from "./SearchForm.vue?vue&type=template&id=6344e555&scoped=true&ts=true"
import script from "./SearchForm.vue?vue&type=script&lang=ts"
export * from "./SearchForm.vue?vue&type=script&lang=ts"

import "./SearchForm.vue?vue&type=style&index=0&id=6344e555&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/atomic-design/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6344e555"]])

export default __exports__